import { useEffect, useState } from 'react'
import { Skeleton } from '@mui/material'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { getIdsfromShortName } from 'src/helper/getIdsThroughData'
import { useNotify } from 'react-admin'
import { roleServices } from 'src/services/auth/rol/rol.service'

export const WrapperRoles = ({ index, setList, item, id }) => {
  const notify = useNotify()
  const [loadingRoles, setLoadingRoles] = useState(false)

  useEffect(() => {
    if (item.clients.checkedClient && item.applications.checkedApplication) {
      ;(async () => {
        setLoadingRoles(true)
        try {
          let allRolesByApplication = await roleServices.getRolesByApplicationAndClient(
            item.applications.checkedApplication,
            item.clients.checkedClient
          )
          if (!allRolesByApplication) {
            notify('ra.notification.noRoleApplication', { type: 'error' })
            return
          }

          const setValue = () => {
            return {
              optionsRole: allRolesByApplication,
              selectedRole: [],
            }
          }

          setList((prev) => prev.map((item) => (item.id === id ? { ...item, roles: setValue() } : item)))
          setLoadingRoles(false)
        } catch (error) {
          notify('ra.notification.noRoleApplication', { type: 'error' })
        } finally {
          setLoadingRoles(false)
          return
        }
      })()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.applications.checkedApplication, item.clients.checkedClient])

  const onRolesChange = (e) => {
    const value = e.target.value
    const newVal = typeof value === 'string' ? value.split(',') : value
    const setValue = (value) => {
      return {
        optionsRole: value.roles.optionsRole,
        selectedRole: newVal,
        selectedRoleId: getIdsfromShortName(value.roles.optionsRole, newVal),
      }
    }
    setList((prev) => prev.map((item) => (item.id === id ? { ...item, roles: setValue(item) } : item)))
  }

  return (
    <>
      {loadingRoles ? (
        <Skeleton variant='rectangular' width={'100%'} height={40} />
      ) : (
        <SelectInput
          source={`aplications[${index}].role_id`}
          options={item.roles.optionsRole}
          defaultValue={item.roles.selectedRole}
          onChange={onRolesChange}
          optionsText={['short_name', 'long_name']}
          multiple
          showSearch
        />
      )}
    </>
  )
}
